import { RouteRecordRaw } from 'vue-router';

const legalRoutes: RouteRecordRaw[] = [
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import(/* webpackChunkName: "privacy" */ '@/views/PrivacyPolicyView.vue'),
    meta: {
      title: 'Privacy Policy',
      requiresAuth: false,
    },
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import(/* webpackChunkName: "terms" */ '@/views/TermsView.vue'),
    meta: {
      title: 'Terms of Service',
      requiresAuth: false,
    },
  },
];

export default legalRoutes;